<template>
  <span>
    <v-dialog v-model="showModel" width="360" hide-overlay :retain-focus="false" scrollable persistent
    content-class="calls-log">
    <v-card>
      <v-card-title>
        <v-icon>mdi-history</v-icon>&nbsp;
        {{ $t('sipua.menu.callsLog') }} ({{ calls.length }})
        <v-spacer></v-spacer>
        <v-btn icon small @click="$emit('show-calls-log', false)">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="padding:0px; max-height: 300px">
        <v-list>
          <v-list-item @click="dial(call.num)" v-for="(call, idx) in calls" :key="idx">
            <v-list-item-content class="calls-log-item">
              <v-list-item-title style="font-size:14px">
                <v-icon small :color="iconColor(call)">
                  {{ iconDir(call) }}
                </v-icon>
                {{ call.num | formatPhoneNum(countryCode) }}
              </v-list-item-title>
              <v-list-item-subtitle style="font-size:12px">
                <span>{{ call.name }}</span><br>
                <span class="calls-log-date">{{ call.time | formatDateLong($i18n.locale) }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-menu v-if="contextMenusWithPermission.length > 0" style="z-index: 999">
              <template v-slot:activator="{ on, attrs }">
              <v-btn
                  icon
                  v-on:click.prevent
                  v-bind="attrs"
                  v-on="on"
                  class="context-menu-btn-calls-log"
              >
                  <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(contextMenu, index) in contextMenusWithPermission"
                  :key="index"
                  style="display: -webkit-box !important;"
                  class="context-menu-item-calls-log"
                  @click="handleMenuAction(contextMenu, call)"
                >
                  <v-list-item-icon>
                  <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ capitalizeFirstLetter($t(`chat.contextMenu.${contextMenu.key}`)) }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>

          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
  <ContactForm/>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CallsLog from '@/api/callslog'
import Contact from 'Store/class/contact/contact'
import ContactForm from '@/components/contacts/forms/contact_dialog'

export default {
  name: 'calls-log',
  props: {
    show: {
      type: Boolean
    },
    pattern: {
      type: String,
      default: ''
    }
  },
  components: { ContactForm },
  computed: {
    ...mapGetters({
      callsLog: 'callsLog',
      callsFilter: 'callslog/filtered',
      countryCode: 'countryCode',
      contactsManagePersonal: 'permissions/contactsManagePersonal',
      contactsWrite: 'permissions/contactsWrite',
      isOwnerCurUser: 'settings/isOwnerCurUser',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers'
    }),
    calls: function () {
      const callsData = (!this.pattern || this.pattern.length === 0) ? this.callsLog : this.callsFilter(this.pattern)
      return callsData.map((call) => {
        const temp = { ...call }
        if (call.name.length === 0) {
          const contact = this.phoneNumbers.find((number) => { return number.phoneNumber.replace(/\D/g, '') === call.num.replace(/\D/g, '') })
          temp.name = ''
          if (contact) {
            temp.name = contact.name
            if (contact.name === 'feature_code') {
              temp.name = this.$t(`contacts.featureCodes.${contact.label}`)
            }
          }
        }
        return temp
      })
    },
    showModel: {
      get: function () {
        return this.show
      },
      set: function (val) {
        this.$emit('show-call-logs', val)
      }
    },
    contextMenusWithPermission: function () {
      const data = []
      if (this.contactsWrite) {
        data.push({ title: 'Add Shared Contact', key: 'add_shared_contact', icon: 'mdi-plus', color: 'default' })
      }
      if (this.contactsManagePersonal) {
        data.push({ title: 'Add Personal Contact', key: 'add_personal_contact', icon: 'mdi-plus', color: 'default' })
      }
      if (this.isOwnerCurUser) {
        data.push({ title: 'Add to Blacklist', key: 'add_blacklist', icon: 'mdi-account-cancel', color: 'default' })
      }
      return data
    }
  },
  watch: {
    show: function (newVal, oldVal) {
      if (newVal) {
        this.clearMissedCalls()
      }
    }
  },
  methods: {
    ...mapActions(['clearMissedCalls']),
    ...mapActions({
      openContactForm: 'contacts/form/open',
      saveBlacklist: 'settings/saveBlacklist'
    }),
    printTime: function (stamp) {
      const date = new Date(stamp)
      const lang = window.navigator.language
      const opts = {
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }
      return date.toLocaleString(lang, opts)
    },
    dial: function (num) {
      this.$emit('init-call', num)
      this.$emit('show-calls-log', false)
    },
    iconColor: function (call) {
      switch (true) {
        case CallsLog.isMissed(call):
          return 'red accent-4'
        case CallsLog.isDialed(call):
          return 'green'
        case CallsLog.isRecevd(call):
          return 'primary'
        default:
          return 'grey darken-2'
      }
    },
    iconDir: function (call) {
      switch (true) {
        case CallsLog.isMissed(call):
          return 'mdi-phone-missed'
        case CallsLog.isDialed(call):
          return 'mdi-arrow-top-right'
        case CallsLog.isRecevd(call):
          return 'mdi-arrow-bottom-left'
        default:
          return 'mdi-help-circle-outline'
      }
    },
    handleMenuAction: function (contextMenu, call) {
      const action = contextMenu.key
      switch (action) {
        case 'add_shared_contact':
          this.addContact(call, false)
          break
        case 'add_personal_contact':
          this.addContact(call, true)
          break
        case 'add_blacklist':
          this.addBlacklist(call)
          break
      }
    },
    addContact: function (call, isPersonal) {
      const isUpdate = false
      const contact = new Contact({})
      contact.isPersonal = isPersonal
      contact.phoneNumbers[0].phone_number = call?.num || ''
      contact.lastName = call?.name || ''
      this.openContactForm({ contact, isUpdate })
    },
    addBlacklist: function (call) {
      this.saveBlacklist({ name: call.name, number: call.num })
    },
    capitalizeFirstLetter (string) {
      return string?.charAt(0).toUpperCase() + string?.slice(1)
    }
  }
}
</script>

<style>
.calls-log {
  position: relative;
  left: 365px;
}

.calls-log-date {
  font-weight: bold;
  color: #CCC;
}

.addContactIcon:hover {
  cursor: pointer;
  color: #1876d1;
}
</style>
